import { IonItem } from '@ionic/react';
import { Report, calcDateSpanDescription } from 'model';
// eslint-disable-next-line css-modules/no-unused-class
import shareStyles from '../../styles/Shared.module.css';
import { ProfilePic } from '../ProfilePic';
import styles from './ReportItem.module.css';

import { useGetProfileQuery } from '../../api/UserApi';
import { IconChatbox, IconEdit } from '../QuirkIcons';

export const ReportItem: React.FC<{ item: Report; openModal: () => void }> = ({ item, openModal }) => {
	const { data: user } = useGetProfileQuery(item.reporter);

	return (
		<>
			{user && (
				<IonItem className={styles.ionItem}>
					<div className={styles.reportItemContainer} onClick={openModal}>
						<div className={shareStyles.authorHeader}>
							<div className={styles.iconContainer}>
								{item.documentType === 'post' ? <IconEdit /> : <IconChatbox />}
							</div>
							<ProfilePic user={user} testId={`ProfilePic-${user._id}`} />
							<div>
								<div className={shareStyles.name}>{user.username}</div>
								<div>
									<span className={shareStyles.time}>
										{calcDateSpanDescription(new Date(item.created).toISOString())}
									</span>
								</div>
							</div>
						</div>
						<div className={styles.flagCountContainer}>{item.reason}</div>
					</div>
				</IonItem>
			)}
		</>
	);
};
